/*
 * @Author: Teemo Ding
 * @Date: 2021-09-16 10:24:06
 * @LastEditTime: 2022-06-02 11:23:13
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/Edit/DNSRecordRecommendation/index.tsx
 */
import { Alert, Button, Checkbox, Form } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Icon } from '@/src/tools/icon';
import {
  EnumStatus,
  DNSErrorCodes,
  DistributionStatus,
} from '@/src/types/common/domain';
import { Collapse } from 'antd';
import React, { useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';
import { Modal, ModalFooter } from '@/src/components/Antd';

const { Item } = Form;
const { Panel } = Collapse;

const DNSRecordRecommendation = ({
  domain,
  domainStatus,
  awsDistributionDomainName,
  certificate,
  verifyDomain,
  verifiedDate,
  success,
  errorCode,
  errorMsg,
  distributionStatus,
  btnDisableWhileReq,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [fold, setFold] = useState(false);
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const { status: certificateStatus = '' } = certificate || {};
  const wwwRegex = new RegExp(/^www\./);
  const wwwDomain = wwwRegex.test(domain);
  // const wwwDomainUrl = (domain || '').replace(wwwRegex, '');
  const domainLength = (domain || '').split('.').length - 1;
  // const rootDomain = domainLength == 1;
  const subDomain = domainLength == 2;
  // const dataformat = handleOnGetCurrentSCDateFormat() || 'MMM DD, YYYY';
  const disabledAll = !certificateStatus;
  const deletingStatus = domainStatus === EnumStatus.Deleting;

  const renderAlert = (statusItem, success, errorCode, errorMsg) => {
    const isPendingWithNoError =
      statusItem == EnumStatus.Pending &&
      (errorCode === 0 || !DNSErrorCodes.includes(errorCode)) &&
      distributionStatus === DistributionStatus.Creating;

    return isPendingWithNoError ||
      (!success && DNSErrorCodes.includes(errorCode) && isAlertVisible) ? (
      <Alert
        className={css.certificateAlert}
        closable={!isPendingWithNoError}
        onClose={() => {
          setIsAlertVisible(false);
        }}
        message={
          isPendingWithNoError
            ? getI18n(
                'salesChannelDomainAndStatus.edit.domainVerificationProcessing',
              )
            : getI18n(
                'salesChannelDomainAndStatus.edit.domainVerificationFailed',
              )
        }
        showIcon
        type={isPendingWithNoError ? 'info' : 'error'}
        icon={
          <Icon
            type={isPendingWithNoError ? 'iconpending' : 'iconfailed'}></Icon>
        }
        description={
          isPendingWithNoError ? (
            getI18n('salesChannelDomainAndStatus.edit.statusItemPending')
          ) : (
            <>
              {getI18n('salesChannelDomainAndStatus.edit.statusItemnotPending')}
              <br />
              {!success && DNSErrorCodes.includes(errorCode) ? (
                errorMsg ? (
                  getI18n(`salesChannelDomainAndStatus.error.${errorCode}`) +
                  ':' +
                  errorMsg
                ) : (
                  getI18n(`salesChannelDomainAndStatus.error.${errorCode}`)
                )
              ) : (
                <></>
              )}
            </>
          )
        }
      />
    ) : null;
  };

  const renderItem = (
    <div>
      {renderAlert(domainStatus, success, errorCode, errorMsg)}
      <p className={css.recordRecommendation}>
        {getI18n('salesChannelDomainAndStatus.edit.recordRecommendation')}
      </p>
      {!domain && (
        <p>
          {getI18n('salesChannelDomainAndStatus.edit.nodomaincertificatetips')}
        </p>
      )}
      {!!domain && (wwwDomain || subDomain) && (
        <div>
          <p className={css.wwwDomainTitle}>
            {getI18n('salesChannelDomainAndStatus.edit.updateCNAMEof')}{' '}
            <span className={css.green}>{domain}</span>{' '}
            {getI18n('salesChannelDomainAndStatus.edit.wwwDomainTitle4')}
          </p>
          <p className={css.awsDistributionDomainName}>
            {awsDistributionDomainName}
          </p>
          {!awsDistributionDomainName ? (
            <p className={css.awsDistributionDomainName}>
              {getI18n('salesChannelDomainAndStatus.edit.getCNAMEdetailstips')}
            </p>
          ) : (
            <></>
          )}
        </div>
      )}
      {/* remove root domain and IPConfig UXPSA-12917 */}
      {/* {!!domain && wwwDomain && (
        <div>
          <p className={css.wwwDomainTitle}>
            {getI18n('salesChannelDomainAndStatus.edit.wwwDomainTitle1')}{' '}
            <span className={css.green}>{wwwDomainUrl}</span>{' '}
            {getI18n('salesChannelDomainAndStatus.edit.wwwDomainTitle2')}:
          </p>
          {!awsDistributionDomainIp ? (
            <p className={css.wwwDomainContent}>
              {getI18n('salesChannelDomainAndStatus.edit.wwwDomainContent')}{' '}
            </p>
          ) : (
            <p className={css.wwwDomainContent}>{awsDistributionDomainIp} </p>
          )}
        </div>
      )} */}
      {/* {!!domain && rootDomain && (
        <div>
          <p className={css.wwwDomainTitle}>
            {getI18n(
              'salesChannelDomainAndStatus.edit.updateArecordtoIPaddress',
            )}
          </p>
          <span>{awsDistributionDomainIp}</span>
          {!awsDistributionDomainIp ? (
            <p className={css.wwwDomainContent}>
              {getI18n('salesChannelDomainAndStatus.edit.wwwDomainContent')}{' '}
            </p>
          ) : (
            <></>
          )}
        </div>
      )}
      {!!domain && rootDomain && (
        <p className={css.wwwDomainTitle}>
          {getI18n('salesChannelDomainAndStatus.edit.wwwDomainTitle1')}{' '}
          <span className={css.green}>www.{domain}</span>{' '}
          {getI18n('salesChannelDomainAndStatus.edit.wwwDomainTitle3')}{' '}
          <span className={css.green}>www.{domain}</span>{' '}
          {getI18n('salesChannelDomainAndStatus.edit.wwwDomainTitle4')}{' '}
          <span className={css.green}>{domain}</span>​
        </p>
      )} */}
      {!!domain && (
        <div className={css.rootTips}>
          {getI18n('salesChannelDomainAndStatus.edit.rootdomainTips')}
        </div>
      )}
      <Item name='notify' className={css.notify} valuePropName='checked'>
        <Checkbox disabled={disabledAll}>
          {getI18n('salesChannelDomainAndStatus.edit.notifyme')}
        </Checkbox>
      </Item>
      <Button
        type='primary'
        disabled={disabledAll || deletingStatus || btnDisableWhileReq}
        onClick={() => {
          setShowVerifyModal(true);
        }}
        className={css.primaryButton}>
        {getI18n('salesChannelDomainAndStatus.edit.verifyConnection')}
      </Button>
    </div>
  );
  return (
    <>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={css.containerClassName}
        titleOnClick={() => setFold(!fold)}
        rightPart={<Icon type={fold ? 'icondown1' : 'iconright'}></Icon>}
        hideContent={!fold}
        title={getI18n(
          'salesChannelDomainAndStatus.edit.dNSRecordRecommendation',
        )}>
        {verifiedDate && (
          <div className={css.certificateVerified}>
            <p className={css.certificateTitle}>
              {getI18n('salesChannelDomainAndStatus.edit.connectionVerified')}
            </p>
            <p className={css.verifiedData}>
              {getI18n('salesChannelDomainAndStatus.edit.verifiedon')}{' '}
              {verifiedDate || ''}
            </p>
          </div>
        )}
        {verifiedDate ? (
          <Collapse className={css.collapse} ghost>
            <Panel
              key='1'
              header={getI18n(
                'salesChannelDomainAndStatus.edit.dNSSettingsInstruction',
              )}>
              {renderItem}
            </Panel>
          </Collapse>
        ) : (
          renderItem
        )}
      </SectionWrapper>
      {showVerifyModal && (
        <Modal
          width={600}
          visible={showVerifyModal}
          onCancel={() => {
            setShowVerifyModal(false);
          }}
          title={getI18n('salesChannelDomainAndStatus.edit.verifyConnection')}>
          <div className={css.verifyModal}>
            {getI18n('salesChannelDomainAndStatus.edit.verifyConnectionModal')}
          </div>
          <ModalFooter
            onCancel={() => {
              setShowVerifyModal(false);
            }}
            okText={getI18n('general.antd.Modal.ModalFooter.confirm')}
            onOk={async () => {
              await verifyDomain();
              setShowVerifyModal(false);
              setIsAlertVisible(true);
            }}
          />
        </Modal>
      )}
    </>
  );
};

export default DNSRecordRecommendation;
